function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 120.5,
  cy: 120.5,
  r: 120.5,
  fill: "#EEF9F5"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 120.314,
  cy: 120.953,
  r: 76.6729,
  fill: "#E1F5EE"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 119.953,
  cy: 112.934,
  r: 36.1186,
  fill: "#C0E9DA"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 119.953,
  cy: 111.124,
  r: 25.5147,
  stroke: "black",
  strokeWidth: 6
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M78.4111 111.042H160.589V160.235C160.589 164.653 157.007 168.235 152.589 168.235H86.4111C81.9929 168.235 78.4111 164.653 78.4111 160.235V111.042Z",
  fill: "#81D2B5",
  stroke: "black",
  strokeWidth: 4
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 105.889,
  cy: 133.43,
  r: 3.98346,
  fill: "black"
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  cx: 134.304,
  cy: 133.43,
  r: 3.98346,
  fill: "black"
});

var _ref9 = /*#__PURE__*/React.createElement("line", {
  x1: 126.758,
  y1: 151.73,
  x2: 111.841,
  y2: 151.73,
  stroke: "black",
  strokeWidth: 5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref10 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 144.064,
  cy: 142.06,
  rx: 5.77602,
  ry: 2.9212,
  fill: "#FC8181",
  fillOpacity: 0.5
});

var _ref11 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 96.129,
  cy: 142.06,
  rx: 5.77602,
  ry: 2.9212,
  fill: "#FC8181",
  fillOpacity: 0.5
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M145.57 99.0843C146.053 98.8429 147.055 98.1248 147.2 97.1833",
  stroke: "#4D7E6D"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M147.652 96.1876C147.833 95.4634 148.286 93.997 148.648 93.9246",
  stroke: "#4D7E6D"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M149.463 93.1098C149.855 92.4761 150.785 91.2812 151.364 91.5709",
  stroke: "#4D7E6D"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M111.534 106.869C111.654 106.296 112.131 105.095 113.073 104.878",
  stroke: "#4D7E6D"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M114.611 104.787C115.305 104.938 116.748 105.149 116.965 104.787",
  stroke: "#4D7E6D"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M118.594 104.335C119.137 104.184 120.278 103.701 120.495 102.977",
  stroke: "#4D7E6D"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M121.039 102.072C121.31 101.408 121.962 100.08 122.396 100.08",
  stroke: "#4D7E6D"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M123.211 99.3559C123.573 98.9636 124.388 98.1429 124.75 97.998",
  stroke: "#4D7E6D"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M125.746 97.2739C126.349 96.8213 127.755 95.9523 128.552 96.0971",
  stroke: "#4D7E6D"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M130 96.2782C130.694 96.1877 132.155 96.1334 132.445 96.6403",
  stroke: "#4D7E6D"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M134.165 97.4548C134.708 97.8471 135.903 98.5954 136.337 98.4506",
  stroke: "#4D7E6D"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M137.604 98.7222C138.329 99.0541 139.868 99.6636 140.23 99.4464",
  stroke: "#4D7E6D"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M141.678 99.8991C142.523 99.9293 144.303 99.881 144.665 99.4465",
  stroke: "#4D7E6D"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M156.617 90.9612C156.342 90.4948 155.851 89.2426 156.089 87.9649M155.185 91.5999C154.77 90.7076 154.058 88.7092 154.525 87.8545",
  stroke: "black"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M155.351 91.4491C154.562 91.5884 153.828 91.484 153.284 91.2279C152.739 90.9711 152.424 90.5865 152.351 90.1688C152.277 89.7512 152.441 89.2822 152.865 88.8544C153.289 88.4278 153.943 88.0787 154.732 87.9395C155.522 87.8003 156.256 87.9046 156.8 88.1607C157.345 88.4175 157.659 88.8021 157.733 89.2198C157.807 89.6374 157.643 90.1064 157.218 90.5342C156.795 90.9609 156.141 91.3099 155.351 91.4491Z",
  stroke: "black"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M157.333 90.6422C157.927 91.8246 158.692 94.1872 156.991 94.1781C154.865 94.1668 155.35 92.5366 155.559 91.5342",
  stroke: "black"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M156.909 87.8468C157.063 86.5323 156.973 84.0508 155.378 84.641C153.384 85.3788 154.398 86.7448 154.937 87.6152",
  stroke: "black"
});

var _ref29 = /*#__PURE__*/React.createElement("mask", {
  id: "path-28-inside-1",
  fill: "white"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 158.754,
  cy: 88.8468,
  rx: 1.3311,
  ry: 0.950788,
  transform: "rotate(80 158.754 88.8468)"
}));

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M158.811 89.1729C158.953 89.1479 159.004 89.2238 158.956 89.1768C158.909 89.1314 158.834 89.0187 158.802 88.8383L156.833 89.1856C156.928 89.7292 157.178 90.2349 157.555 90.6042C157.929 90.9719 158.499 91.2587 159.159 91.1425L158.811 89.1729ZM158.802 88.8383C158.77 88.6579 158.803 88.5262 158.831 88.4677C158.859 88.4072 158.838 88.4957 158.696 88.5208L158.349 86.5511C157.69 86.6674 157.252 87.1319 157.026 87.6055C156.799 88.0813 156.737 88.642 156.833 89.1856L158.802 88.8383ZM158.696 88.5208C158.554 88.5458 158.504 88.4698 158.552 88.5169C158.598 88.5622 158.674 88.675 158.705 88.8554L160.675 88.5081C160.579 87.9645 160.329 87.4588 159.953 87.0894C159.578 86.7218 159.008 86.4349 158.349 86.5511L158.696 88.5208ZM158.705 88.8554C158.737 89.0358 158.705 89.1675 158.677 89.2259C158.648 89.2865 158.669 89.1979 158.811 89.1729L159.159 91.1425C159.818 91.0263 160.255 90.5617 160.482 90.0881C160.709 89.6124 160.771 89.0517 160.675 88.5081L158.705 88.8554Z",
  fill: "black",
  mask: "url(#path-28-inside-1)"
});

var _ref31 = /*#__PURE__*/React.createElement("line", {
  x1: 93.8424,
  y1: 77.1307,
  x2: 89.2538,
  y2: 70.5775,
  stroke: "black",
  strokeWidth: 5,
  strokeLinecap: "round"
});

var _ref32 = /*#__PURE__*/React.createElement("line", {
  x1: 148.938,
  y1: 69.4818,
  x2: 144.35,
  y2: 76.035,
  stroke: "black",
  strokeWidth: 5,
  strokeLinecap: "round"
});

var _ref33 = /*#__PURE__*/React.createElement("line", {
  x1: 117.5,
  y1: 67.5,
  x2: 117.5,
  y2: 56.5,
  stroke: "black",
  strokeWidth: 5,
  strokeLinecap: "round"
});

var _ref34 = /*#__PURE__*/React.createElement("line", {
  x1: 174.833,
  y1: 27.5,
  x2: 174.833,
  y2: 36.5,
  stroke: "#81D2B5",
  strokeLinecap: "round"
});

var _ref35 = /*#__PURE__*/React.createElement("line", {
  x1: 179.5,
  y1: 31.5,
  x2: 170.5,
  y2: 31.5,
  stroke: "#81D2B5",
  strokeLinecap: "round"
});

var _ref36 = /*#__PURE__*/React.createElement("line", {
  x1: 220.833,
  y1: 87.5,
  x2: 220.833,
  y2: 96.5,
  stroke: "#C4ADA7",
  strokeLinecap: "round"
});

var _ref37 = /*#__PURE__*/React.createElement("line", {
  x1: 225.5,
  y1: 91.5,
  x2: 216.5,
  y2: 91.5,
  stroke: "#C4ADA7",
  strokeLinecap: "round"
});

var _ref38 = /*#__PURE__*/React.createElement("line", {
  x1: 52.8335,
  y1: 103.5,
  x2: 52.8335,
  y2: 112.5,
  stroke: "#8ED7BC",
  strokeLinecap: "round"
});

var _ref39 = /*#__PURE__*/React.createElement("line", {
  x1: 57.5,
  y1: 107.5,
  x2: 48.5,
  y2: 107.5,
  stroke: "#8ED7BC",
  strokeLinecap: "round"
});

var _ref40 = /*#__PURE__*/React.createElement("line", {
  x1: 173.833,
  y1: 157.5,
  x2: 173.833,
  y2: 166.5,
  stroke: "#8ED7BC",
  strokeLinecap: "round"
});

var _ref41 = /*#__PURE__*/React.createElement("line", {
  x1: 178.5,
  y1: 161.5,
  x2: 169.5,
  y2: 161.5,
  stroke: "#8ED7BC",
  strokeLinecap: "round"
});

var _ref42 = /*#__PURE__*/React.createElement("circle", {
  cx: 76,
  cy: 22,
  r: 4.5,
  stroke: "#8ED7BC"
});

var _ref43 = /*#__PURE__*/React.createElement("circle", {
  cx: 182,
  cy: 193,
  r: 4.5,
  stroke: "#FFD1BF"
});

var _ref44 = /*#__PURE__*/React.createElement("circle", {
  cx: 34,
  cy: 170,
  r: 4.5,
  stroke: "#C4ADA7"
});

var _ref45 = /*#__PURE__*/React.createElement("circle", {
  cx: 197,
  cy: 118,
  r: 4.5,
  stroke: "#8ED7BC"
});

var _ref46 = /*#__PURE__*/React.createElement("circle", {
  cx: 99.6875,
  cy: 207.5,
  r: 3.5625,
  stroke: "#FF388B",
  strokeOpacity: 0.5
});

var _ref47 = /*#__PURE__*/React.createElement("line", {
  x1: 102.66,
  y1: 205.459,
  x2: 105.098,
  y2: 203.834,
  stroke: "#FF388B",
  strokeOpacity: 0.5
});

var _ref48 = /*#__PURE__*/React.createElement("line", {
  x1: 93.7226,
  y1: 211.146,
  x2: 96.1601,
  y2: 209.521,
  stroke: "#FF388B",
  strokeOpacity: 0.5
});

var _ref49 = /*#__PURE__*/React.createElement("line", {
  x1: 99.1875,
  y1: 203.438,
  x2: 99.1875,
  y2: 201,
  stroke: "#FF388B",
  strokeOpacity: 0.5
});

var _ref50 = /*#__PURE__*/React.createElement("line", {
  x1: 99.1875,
  y1: 214,
  x2: 99.1875,
  y2: 211.562,
  stroke: "#FF388B",
  strokeOpacity: 0.5
});

var _ref51 = /*#__PURE__*/React.createElement("line", {
  x1: 96.1601,
  y1: 206.291,
  x2: 93.7226,
  y2: 204.666,
  stroke: "#FF388B",
  strokeOpacity: 0.5
});

var _ref52 = /*#__PURE__*/React.createElement("line", {
  x1: 105.098,
  y1: 211.979,
  x2: 102.66,
  y2: 210.354,
  stroke: "#FF388B",
  strokeOpacity: 0.5
});

var _ref53 = /*#__PURE__*/React.createElement("circle", {
  cx: 123.688,
  cy: 43.5,
  r: 3.5625,
  stroke: "#FAD6C2"
});

var _ref54 = /*#__PURE__*/React.createElement("line", {
  x1: 126.66,
  y1: 41.459,
  x2: 129.098,
  y2: 39.834,
  stroke: "#FAD6C2"
});

var _ref55 = /*#__PURE__*/React.createElement("line", {
  x1: 117.723,
  y1: 47.1465,
  x2: 120.16,
  y2: 45.5215,
  stroke: "#FAD6C2"
});

var _ref56 = /*#__PURE__*/React.createElement("line", {
  x1: 123.188,
  y1: 39.4375,
  x2: 123.188,
  y2: 37,
  stroke: "#FAD6C2"
});

var _ref57 = /*#__PURE__*/React.createElement("line", {
  x1: 123.188,
  y1: 50,
  x2: 123.188,
  y2: 47.5625,
  stroke: "#FAD6C2"
});

var _ref58 = /*#__PURE__*/React.createElement("line", {
  x1: 120.16,
  y1: 42.291,
  x2: 117.723,
  y2: 40.666,
  stroke: "#FAD6C2"
});

var _ref59 = /*#__PURE__*/React.createElement("line", {
  x1: 129.098,
  y1: 47.9785,
  x2: 126.66,
  y2: 46.3535,
  stroke: "#FAD6C2"
});

var _ref60 = /*#__PURE__*/React.createElement("circle", {
  cx: 28.6875,
  cy: 72.5,
  r: 3.5625,
  stroke: "#81D2B5"
});

var _ref61 = /*#__PURE__*/React.createElement("line", {
  x1: 31.6601,
  y1: 70.459,
  x2: 34.0976,
  y2: 68.834,
  stroke: "#81D2B5"
});

var _ref62 = /*#__PURE__*/React.createElement("line", {
  x1: 22.7226,
  y1: 76.1465,
  x2: 25.1602,
  y2: 74.5215,
  stroke: "#81D2B5"
});

var _ref63 = /*#__PURE__*/React.createElement("line", {
  x1: 28.1875,
  y1: 68.4375,
  x2: 28.1875,
  y2: 66,
  stroke: "#81D2B5"
});

var _ref64 = /*#__PURE__*/React.createElement("line", {
  x1: 28.1875,
  y1: 79,
  x2: 28.1875,
  y2: 76.5625,
  stroke: "#81D2B5"
});

var _ref65 = /*#__PURE__*/React.createElement("line", {
  x1: 25.1601,
  y1: 71.291,
  x2: 22.7227,
  y2: 69.666,
  stroke: "#81D2B5"
});

var _ref66 = /*#__PURE__*/React.createElement("line", {
  x1: 34.0976,
  y1: 76.9785,
  x2: 31.6602,
  y2: 75.3535,
  stroke: "#81D2B5"
});

function SvgEmptyBag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 241,
    height: 241,
    viewBox: "0 0 241 241",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyBag);
export default __webpack_public_path__ + "static/media/empty_bag.d8d3c71a.svg";
export { ForwardRef as ReactComponent };